<template>
  <div>
    <el-table
        :data="formattedVideos"
        :default-sort="{ prop: order_column, order: order_type }"
        class="w100"
        stripe
    >
      <el-table-column label="Video Title" prop="video_title">
        <template slot-scope="props">
          <a
              :href="`https://youtube.com/watch?v=${props.row.video_id}`"
              target="_blank"
          >
            {{ props.row.video_title }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Video Id" prop="video_id"></el-table-column>
      <el-table-column label="Channel Id" prop="channel_id"></el-table-column>
      <el-table-column label="Asset title" prop="title"></el-table-column>
      <el-table-column label="Status" prop="status">
        <template slot-scope="props">
          <el-tag
              v-if="props.row.status == 'no claim'"
              type="danger"
          >
            {{ props.row.status }}
          </el-tag>
          <el-tag v-else type="success">
            {{ props.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Published date" prop="published_date"></el-table-column>
    </el-table>
    <el-pagination
        class="float-right"
        background
        @current-change="currentChange"
        :current-page.sync="videos.current_page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="videos.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import format from "date-fns/format";

export default {
  computed: {
    ...mapState("channelVideoClaims", [
      "videos",
      "loading",
      "order_column",
      "order_type",
    ]),

    formattedVideos() {
      return this.videos && this.videos.data
          ? this.videos.data.map((video) => ({
            ...video,
            formattedViews: Number(video.total_views).toLocaleString('en-US'),
            formattedRevenue: new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(video.total_revenue),
          }))
          : [];
    },
  },

  methods: {
    ...mapMutations("channelVideoClaims", ["setPage", "setOrdering"]),
    ...mapActions("channelVideoClaims", ["readVideos"]),
    currentChange(currentPage) {
      this.setPage(currentPage);
      this.readVideos();
    },
  },

  created() {
    this.readVideos();
  },
};
</script>